import { LanguageISO6391 } from 'ai-constants'
import { InitOptions } from 'i18next'
import en from './locale/merged.en.json'
import es from './locale/merged.es.json'

export const defaultLanguage = 'es' satisfies LanguageISO6391
const singleBraceInterpolationPattern = /(^|[^{}])\{([a-zA-Z0-9_.-]+)\}(?!\})/g

const normalizeInterpolationSyntax = (locale: Record<string, string>) =>
  Object.entries(locale).reduce<Record<string, string>>((acc, [key, value]) => {
    acc[key] = value.replace(singleBraceInterpolationPattern, '$1{{$2}}')

    return acc
  }, {})

export const getInitialLanguage = () => {
  if (typeof document === 'undefined') return defaultLanguage

  const cookies = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .reduce<Record<string, string>>((acc, cookieEntry) => {
      const [key, ...value] = cookieEntry.split('=')

      if (!key) return acc

      acc[key] = value.join('=')

      return acc
    }, {})

  const nextLocale = cookies.NEXT_LOCALE

  return nextLocale === 'en' ? 'en' : defaultLanguage
}

export const resources = {
  en: {
    common: normalizeInterpolationSyntax(en),
  },
  es: {
    common: normalizeInterpolationSyntax(es),
  },
} satisfies Record<LanguageISO6391, { common: Record<string, string> }>

export const getI11nOptions = (lang: LanguageISO6391 = getInitialLanguage()) =>
  ({
    resources,
    lng: lang,
    fallbackLng: defaultLanguage,
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
    returnNull: false,
  } satisfies InitOptions)
